module.exports = __webpack_public_path__ + "static/img/装11.ea71236.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/decorativePainting/imgs/装11.png
// module id = U+Eh
// module chunks = 2